import React from 'react';
import './Preloader.css';

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="loader"></div> {/* Updated loader */}
    </div>
  );
};

export default Preloader;
